export default __webpack_public_path__ + "static/media/hero-image@2x.3e9de2a4.png";